<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M9.40123 3.0034c1.15447-2.00111 4.04267-2.00111 5.19707 0l7.3544 12.7475c1.1538 2-.2896 4.4992-2.5986 4.4992H4.64546c-2.30897 0-3.752399-2.4992-2.59855-4.4992L9.40123 3.0034ZM12 8.25c.4142 0 .75.33579.75.75v3.75c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75V9c0-.41421.3358-.75.75-.75Zm0 8.25c.4142 0 .75-.3358.75-.75S12.4142 15 12 15s-.75.3358-.75.75.3358.75.75.75Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M13.0825 3.87791c-.481-.8338-1.6844-.8338-2.1655 0L3.56271 16.6254c-.48077.8333.12066 1.8747 1.08273 1.8747H19.3541c.9621 0 1.5635-1.0414 1.0827-1.8747L13.0825 3.87791Zm-3.89784-.99944c1.25074-2.167873 4.37954-2.167874 5.63024 0L22.1692 15.626c1.25 2.1666-.3137 4.8741-2.8151 4.8741H4.64544c-2.50139 0-4.065103-2.7075-2.8151-4.8741L9.18466 2.87847Zm2.81514 5.12159c.5523 0 1 .44772 1 1v3.75004c0 .5522-.4477 1-1 1s-1-.4478-1-1V9.00006c0-.55228.4477-1 1-1Zm-1 7.75004c0-.5523.4477-1 1-1h.0075c.5523 0 1 .4477 1 1v.0075c0 .5522-.4477 1-1 1h-.0075c-.5523 0-1-.4478-1-1v-.0075Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
